import { useEffect } from 'react';
import { useLocation } from 'react-router';

const PAGE_TITLE = 'Learner Portal';

const isProduction = () =>
  import.meta.env.VITE_PRODUCTION_HOST
    ? window.location.host === import.meta.env.VITE_PRODUCTION_HOST
    : false;

const gaEnabled = () => Boolean(window.gtag);

if (isProduction() && gaEnabled()) {
  window.gtag('config', import.meta.env.VITE_GA_ID, {
    page_path: window.location.pathname + window.location.search,
    page_title: PAGE_TITLE,
  });
}

export const useGATrackPage = () => {
  const location = useLocation();

  // eslint-disable-next-line consistent-return
  useEffect(() => {
    const handleLocationChange = (changedLocation: any) => {
      window.gtag('config', import.meta.env.VITE_GA_ID, {
        page_path: changedLocation.pathname + changedLocation.search,
        page_title: PAGE_TITLE,
      });
    };
    if (isProduction() && gaEnabled()) {
      return handleLocationChange(location);
    }
  }, [location]);
};
